import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import {
	computed,
	defineAsyncComponent,
	h,
	onMounted,
	reactive,
	watch,
} from "vue";
import Messages from "../components/Messages.vue";
import FormShare from "../components/FormShare.vue";
import { TicketModule } from "@/store/modules/Ticket";
import MediaPreview from "../components/MediaPreview.vue";
import Sidebar from "../components/ticketSidebar/index.vue";
import FormStartTicket from "../components/FormStartTicket.vue";
import LockModal from "../components/LockModal.vue";
import { PauseModule } from "@/store/modules/Pause";
import { ModalSidebarState as ModalState, Modals } from "@/types/components";
import { Message, MessageFile } from "vue-advanced-chat";
import { env } from "@/config";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const EditClient = defineAsyncComponent(
	() => import("../components/ticketSidebar/EditClient.vue")
);
// import EditClient from "../components/ticketSidebar/EditClient.vue";
const SearchSidebar = defineAsyncComponent(
	() => import("../components/messageFinder/SearchSidebar.vue")
);
const UserForm = env.DynamicUser
	? defineAsyncComponent(
			() =>
				import(
					/* webpackChunckName: "userdynamicform" */ "../../callcenter/components/UserDynamicForm.vue"
				)
	  )
	: h("div");
const AccountModal = defineAsyncComponent(
	() => import("../components/ticketSidebar/AccountModal.vue")
);
// State data
const state = reactive<{
	[k: string]: ModalState<void | { message: Message }>;
	previewMedia: ModalState<{ message: Message; file?: MessageFile }>;
}>({
	sideBarModal: {
		show: false,
	},
	startTicketModal: {
		show: false,
	},
	previewMedia: {
		show: false,
	},
	editClient: {
		show: false,
	},
	lockModal: {
		show: false,
	},
	accountModal: {
		show: false,
	},
	typificationModal: {
		show: false,
	},
});

watch(
	() => PauseModule.locked,
	(val, prev) => {
		if (!prev && val) state.lockModal.show = true;
	}
);

const animationTime = 500; //ms
const showTicketSidebar = computed(() => TicketModule.openedSidebar);
const showSearchSidebar = computed(() => TicketModule.openedSearchSidebar);

// Methods
function changeModal(
	payload: ModalState<void | { message: Message }>,
	modal: Modals
) {
	state[modal].show = payload.show;
	state[modal].type = payload.type;
	state[modal].params = payload.params;
}
onMounted(() => {
	if (PauseModule.locked) state.lockModal.show = true;
});

return (_ctx: any,_cache: any) => {
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_container, { class: "position-relative layout-container-demo" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_container, { class: "transitioned" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createVNode(Messages, {
                  onChangeModalStartTicket: _cache[0] || (_cache[0] = p => changeModal(p, 'startTicketModal')),
                  onPreviewMedia: _cache[1] || (_cache[1] = p => changeModal(p, 'previewMedia'))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_aside, {
          class: "transitioned ticket-sidebar d-flex",
          style: _normalizeStyle({
					width: `${
						_unref(TicketModule).openedSidebar || _unref(TicketModule).openedSearchSidebar
							? 340
							: 0
					}px`,
				})
        }, {
          default: _withCtx(() => [
            _createVNode(_Transition, {
              duration: _unref(showSearchSidebar) ? animationTime / 2 : animationTime,
              name: _unref(showSearchSidebar) ? 'fadeLeft' : 'fadeRight'
            }, {
              default: _withCtx(() => [
                (_unref(showTicketSidebar))
                  ? (_openBlock(), _createBlock(Sidebar, {
                      key: 0,
                      onChangeModal: _cache[2] || (_cache[2] = p => changeModal(p.payload, p.modal))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["duration", "name"]),
            _createVNode(_Transition, {
              duration: _unref(showTicketSidebar) ? animationTime / 2 : animationTime,
              name: _unref(showTicketSidebar) ? 'fadeLeft' : 'fadeRight'
            }, {
              default: _withCtx(() => [
                (_unref(showSearchSidebar))
                  ? (_openBlock(), _createBlock(_unref(SearchSidebar), { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["duration", "name"])
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_Transition, {
          "enter-active-class": "miniFadeInUp",
          "leave-active-class": "miniFadeOutUp"
        }, {
          default: _withCtx(() => [
            (_unref(state).sideBarModal.show)
              ? (_openBlock(), _createBlock(FormShare, {
                  key: 0,
                  open: _unref(state).sideBarModal.show,
                  type: _unref(state).sideBarModal.type,
                  onChangeModal: _cache[3] || (_cache[3] = p => changeModal(p, 'sideBarModal'))
                }, null, 8, ["open", "type"]))
              : (_unref(state).startTicketModal.show)
                ? (_openBlock(), _createBlock(FormStartTicket, {
                    key: 1,
                    open: _unref(state).startTicketModal.show,
                    onChangeModalStartTicket: _cache[4] || (_cache[4] = p => changeModal(p, 'startTicketModal'))
                  }, null, 8, ["open"]))
                : (_unref(state).previewMedia.show)
                  ? (_openBlock(), _createBlock(MediaPreview, {
                      key: 2,
                      open: _unref(state).previewMedia.show,
                      message: _unref(state).previewMedia.params?.message,
                      file: _unref(state).previewMedia.params?.file,
                      onChangeModal: _cache[5] || (_cache[5] = p => changeModal(p, 'previewMedia'))
                    }, null, 8, ["open", "message", "file"]))
                  : (_unref(state).editClient.show && !_unref(env).DynamicUser)
                    ? (_openBlock(), _createBlock(_unref(EditClient), {
                        key: 3,
                        open: _unref(state).editClient.show,
                        onChangeModal: _cache[6] || (_cache[6] = p => changeModal(p, 'editClient'))
                      }, null, 8, ["open"]))
                    : (_unref(state).editClient.show && _unref(env).DynamicUser)
                      ? (_openBlock(), _createBlock(_unref(UserForm), {
                          key: 4,
                          "model-value": _unref(state).editClient.show,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = (p) => changeModal(p, 'editClient'))
                        }, null, 8, ["model-value"]))
                      : (_unref(state).lockModal.show)
                        ? (_openBlock(), _createBlock(LockModal, {
                            key: 5,
                            open: _unref(state).lockModal.show,
                            onChangeModal: _cache[8] || (_cache[8] = p => changeModal(p, 'lockModal'))
                          }, null, 8, ["open"]))
                        : (_unref(state).accountModal.show)
                          ? (_openBlock(), _createBlock(_unref(AccountModal), {
                              key: 6,
                              open: _unref(state).accountModal.show,
                              type: _unref(state).accountModal.type,
                              onChangeModal: _cache[9] || (_cache[9] = p => changeModal(p, 'accountModal'))
                            }, null, 8, ["open", "type"]))
                          : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})